import classnames from "classnames";
import React from "react";
import { Loader } from "../../../../core/atoms/atoms";

interface Props {
  className?: string;
}

export const PlaceholderCard = ({ className }: Props) => (
  <div className={classnames("no-link placeholder-card content-card", className)} title="Loading...">
    <Loader />
  </div>
);
